import { PanelLeftClose, PanelLeftOpen } from 'lucide-react';
import { useAgentContext } from '@Providers';

import useIsMobile from '../../../CustomHooks/useIsMobile';
import AgentBrand from './AgentBrand';
import HeaderActions from './HeaderActions';
import SessionDropdown from './SessionDropdown';

const Header = () => {
  const { mode, isNavSidebarCollapsed, toggleNavSidebar, setActiveChatId } = useAgentContext();
  const isMobile = useIsMobile();
  // On phones the agent stays fullscreen but uses the compact chrome: conversations
  // live in the header dropdown instead of the side nav, so the nav toggle is hidden.
  const showFullscreenChrome = mode === 'fullscreen' && !isMobile;
  const heightClass = showFullscreenChrome ? 'h-12' : 'h-14';

  return (
    <header
      className={`flex flex-shrink-0 items-center gap-2 border-b border-gray-200 px-3 ${heightClass}`}
      style={{
        backgroundColor: 'rgba(255, 255, 255, 0.85)',
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
      }}>
      {showFullscreenChrome && (
        <button
          type="button"
          aria-label={isNavSidebarCollapsed ? 'Open conversations' : 'Close conversations'}
          title={isNavSidebarCollapsed ? 'Open conversations' : 'Close conversations'}
          onClick={toggleNavSidebar}
          className="flex h-7 w-7 items-center justify-center rounded-md text-gray-500 cursor-pointer transition-colors duration-200 hover:bg-[#7c6cf6]/10 hover:text-[#7c6cf6] focus:outline-none">
          {isNavSidebarCollapsed ? (
            <PanelLeftOpen size={15} strokeWidth={1.75} />
          ) : (
            <PanelLeftClose size={15} strokeWidth={1.75} />
          )}
        </button>
      )}

      {showFullscreenChrome ? <AgentBrand /> : <SessionDropdown />}

      <div className="flex-1 min-w-0" />

      <HeaderActions onNewConversation={() => setActiveChatId(null)} />
    </header>
  );
};

export default Header;
